export { ImageComparisonSlider as default } from './ImageComparisonSlider';
